import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: '/tariffs',
    redirect: '/tariffs/list',
  },
  {
    path: '/tariffs/list',
    name: 'tariffs-list',
    component: () => import('./pages/TariffsListPage.vue'),
    meta: { title: 'Тарифы' },
  },
  {
    path: '/tariffs/users',
    name: 'tariffs-users',
    component: () => import('./pages/UsersPage.vue'),
    meta: { title: 'Пользователи' },
  },
  {
    path: '/tariffs/countries',
    name: 'tariffs-countries',
    component: () => import('./pages/CountriesPage.vue'),
    meta: { title: 'Страны' },
  },
  {
    path: '/tariffs/operators',
    name: 'tariffs-operators',
    component: () => import('./pages/OperatorsPage.vue'),
    meta: { title: 'Операторы' },
  },
  {
    path: '/tariffs/transactions',
    name: 'tariffs-transactions',
    component: () => import('./pages/TransactionsPage.vue'),
    meta: { title: 'Транзакции' },
  },
  {
    path: '/tariffs/buy-templates',
    name: 'tariffs-buy-templates',
    component: () => import('./pages/BuyTemplatesListPage.vue'),
    meta: { title: 'Шаблоны цен закупки' },
  },
];
